/** Function to calculate new target offset for smooth scrolling with lazyloaded images */
function smoothScrollTo(scrollToBtn, duration = 500) {
  const href = scrollToBtn.getAttribute("href");
  const target = document.querySelector(href);
  if (!target) return;
  const startTime = performance.now();
  const startY = window.scrollY;

  const header = document.querySelector("header");
  const headerHeight = header ? header.clientHeight : 0;

  function step() {
    const currentTime = performance.now();
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    const targetOffset =
      target.getBoundingClientRect().top - headerHeight + window.scrollY;

    const distance = targetOffset - startY;

    const newPosition = startY + distance * progress;

    window.scrollTo(0, newPosition);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

/** Smooth scroll to target section */
const scrollToButtons = document.querySelectorAll(".js-scroll-to");
scrollToButtons.forEach((scrollToBtn) => {
  scrollToBtn.addEventListener("click", (event) => {
    event.preventDefault();
    smoothScrollTo(scrollToBtn);
  });
});

/**
 * Hero Videos
 * - active/play the visible video, pause/hide the other
 * - check on load and resize // resize only if screen width has changed - iphone prevention
 * */

const heroVideos = document.querySelectorAll(".js-video-hero");

window.addEventListener("load", checkHeroVideos);

let windowWidth = window.innerWidth;
window.addEventListener("resize", () => {
  if (windowWidth !== window.innerWidth) {
    windowWidth = window.innerWidth;
    checkHeroVideos();
  }
});

function checkHeroVideos() {
  if (!heroVideos.length) return;

  heroVideos?.forEach((heroVideo) => {
    if (getComputedStyle(heroVideo).display === "none") {
      heroVideo.pause();
    } else {
      heroVideo.play();
    }
  });
}

/**
 * Tabs
 * - open/close clicked tabs
 * */

const tabs = document.querySelectorAll(".js-tab");

tabs?.forEach((tab) => {
  tab.addEventListener("click", (event) => {
    event.preventDefault();

    const tabId = tab.getAttribute("data-tab");

    tab
      .closest(".tabs")
      .querySelectorAll(".js-tab")
      ?.forEach((tabBtn) => {
        if (tab === tabBtn) {
          tab.classList.add("active");
        } else {
          tabBtn.classList.remove("active");
        }
      });

    // Show corresponding tab content
    const tabContent = document.querySelector(`[data-tab-content=${tabId}]`);
    tab
      .closest(".tabs")
      .querySelectorAll("[data-tab-content]")
      .forEach((tabPane) => {
        if (tabPane === tabContent) {
          tabPane.classList.add("active");
        } else {
          tabPane.classList.remove("active");
        }
      });
  });
});

/**
 * Swipers
 * - swiper banners
 * - product images
 * */

const swiperBanners = document.querySelector(".js-swiper-banners");
let swiperBanner;
if (swiperBanners) {
  function initBannerSwiper() {
    let currentIndex = 0;

    if (swiperBanner) {
      currentIndex = swiperBanner.activeIndex;
      swiperBanner.destroy();
    }

    swiperBanner = new Swiper(".js-swiper-banners", {
      initialSlide: currentIndex,
      spaceBetween: 1,
      items: 1,
      effect: "fade",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      updateOnWindowResize: true,
      breakpoints: {
        0: {
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
        },
        680: {
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
          },
        },
        850: {
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
        },
        1200: {
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
          },
        },
      },
    });
  }

  window.addEventListener("resize", initBannerSwiper);
  initBannerSwiper();
}

const swiperImages = document.querySelector(".js-product-images");
if (swiperImages) {
  const thumbs = new Swiper(".js-product-thumbs", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      576: {
        spaceBetween: 20,
      },
    },
  });
  const images = new Swiper(".js-product-images", {
    spaceBetween: 10,
    thumbs: {
      swiper: thumbs,
    },
  });
}

/**
 * Responsive Menu
 * - open/close menu
 * - scroll to target section
 * */

const menuItems = document.querySelectorAll(".header__nav a");
menuItems?.forEach((menuItem) => {
  menuItem.addEventListener("click", (event) => {
    if (menuItem.getAttribute("href").indexOf("#") !== -1) {
      event.preventDefault();

      document.body.classList.remove("menu-open");
      smoothScrollTo(menuItem);
    }
  });
});

const menuTrigger = document.querySelector(".js-menu-trigger");
menuTrigger?.addEventListener("click", () => {
  document.body.classList.toggle("menu-open");
});

const menuOverlay = document.querySelector(".js-menu-overlay");
menuOverlay?.addEventListener("click", () => {
  document.body.classList.remove("menu-open");
});

/**
 * Videos
 * - play/pause video
 * - when playing new video, pause the others
 * */

//Play video
const videos = document.querySelectorAll(".js-video");
videos?.forEach((video) =>
  video.addEventListener("click", () => handleVideos(video))
);

function handleVideos(video) {
  const videoEl = video.querySelector("video");
  if (!videoEl) return;
  if (video.classList.contains("video-play")) {
    videoEl.pause();
    video.classList.remove("video-play");
  } else {
    video.classList.add("video-play");
    videoEl.play();

    videos.forEach((otherVideo) => {
      if (otherVideo !== video) {
        otherVideo.classList.remove("video-play");
        const otherVideoEl = otherVideo.querySelector("video");
        if (otherVideoEl) otherVideoEl.pause();
      }
    });
  }
}

/**
 * Parallax
 * - add/remove parallax effect to image
 * */
let currentOffset = 0;
const parallaxSection = document.querySelector(".js-parallax-section");
const parallaxImage = parallaxSection ? parallaxSection.querySelector(".js-parallax-image") : null;

function updateParallax() {
  if (window.innerWidth > 992) {
    const sectionTop = parallaxSection.getBoundingClientRect().top;
    const targetOffset = sectionTop * 0.3;

    currentOffset += (targetOffset - currentOffset) * 0.1;

    parallaxImage.style.transform = `translateY(${currentOffset}px)`;

    requestAnimationFrame(updateParallax);
  } else {
    parallaxImage.style.transform = `translateY(-50%)`;
  }
}

if (parallaxSection) {
  initParallax();
}
window.addEventListener("resize", () => {
  if (parallaxSection && windowWidth !== window.innerWidth) {
    initParallax();
  }
});

function initParallax() {
  requestAnimationFrame(updateParallax);
}

/**
 * Stats
 * - add animation to stats values when they are inside viewport
 * */
const statsSection = document.querySelector(".js-stats-section");
if (statsSection) {
  const stats = statsSection.querySelectorAll(".js-stats-value");

  const animateCount = (el, target, hasSign) => {
    const duration = 1000; // total duration in ms
    const frameRate = 60;
    const totalFrames = Math.round(duration / (1000 / frameRate));
    let frame = 0;

    const countTo = +target;
    const counter = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const currentCount = Math.round(countTo * progress);

      if (frame < totalFrames) {
        el.textContent = currentCount + (hasSign ? "+" : "");
      } else {
        el.textContent = countTo + (hasSign ? "+" : "");
        clearInterval(counter);
      }
    }, 1000 / frameRate);
  };

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = el.getAttribute("data-stats");
          const hasSign = el.getAttribute("data-sign");
          animateCount(el, target, hasSign);
          obs.unobserve(el); // Only run once
        }
      });
    },
    { threshold: 1 }
  );

  stats.forEach((stat) => observer.observe(stat));
}

document.addEventListener("scroll", function () {
  const priceContainer = document.querySelector(".swiper-banners");
  const stickyButtonWrap = document.querySelector(".sticky-button-wrap");

  if (priceContainer && stickyButtonWrap) {
    const section = priceContainer.getBoundingClientRect();
    if (section.top <= 50) {
      stickyButtonWrap.classList.add("active");
    } else {
      stickyButtonWrap.classList.remove("active");
    }
  }
});

new Swiper(".swipers", {
  slidesPerView: 1,
  spaceBetween: 32,
  loop: true,
  navigation: {
    nextEl: ".next",
    prevEl: ".prev",
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    320: {
      slidesPerView: 2,
    },
  },
});
